import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const sendNewRequestEmail = (userId, requestIdInt, requestType, requestDescription) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('userId', userId);
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('requestType', requestType);
        fdd.append('requestDescription', requestDescription);

        axios({
          method : "POST",
          url :  api_url + "/SendNewRequestEmail",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const userActivateEmail = ( email, userfname ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('email', email);
        fdd.append('userfname', userfname);

        axios({
          method : "POST",
          url :  api_url + "/UserActivateEmail",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const spWelcomeEmail = ( email ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData;
        fdd.append('email', email);

        axios({
          method : "POST",
          url :  api_url + "/SpWelcomeEmail",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}